import * as types from '../mutation-types'
const cms = {
  state: {
    projectInfo: {},
    img:{}
  },
  getters: {
    projectInfo: state => state.projectInfo,
    img: state => state.img
  },
  mutations: {
    [types.SET_PROJECTINFO] (state, data) {
      state.projectInfo = data
      state.img = data.sectionList[0].fileList
      // console.log(state.img)
    }
  },
  actions: {
  }
}

export default cms
